<template>
    <v-list-item
      v-if="!item.children"
      :class="{ 'menu-item--active': isItemActive(item) }"
      :link="Boolean(item.route)"
      :to="item.route || undefined"
      color="primary"
      @click="handleItemClick(item)"
    >
      <v-list-item-icon>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-icon>
  
      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  
    <v-list-group
      v-else
      no-action
      :prepend-icon="item.icon"
      :value="false"
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </template>
  
      <v-list-item
        v-for="(childItem, index) in item.children"
        :key="index"
        :class="{ 'menu-item--active': isItemActive(childItem) }"
        :link="Boolean(childItem.route)"
        :to="childItem.route || undefined"
        @click="handleItemClick(childItem)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ childItem.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
  </template>
  
  <script>
  import { eventHub } from "@/main";
  
  export default {
    name: "MenuItem",
  
    props: ["item"],
  
    methods: {
      isItemActive(item) {
        if (!item.route) return false;

        const currentPath = this.$route.path;
        const itemRoute = item.route.replace(/\/$/, "");

        return currentPath === itemRoute || currentPath.startsWith(`${itemRoute}/`);
      },

      handleItemClick(item) {
        if (item.event) {
          eventHub.$emit(item.event);
        } else {
          eventHub.$emit('close-menu');
        }
  
        // Router navigation is handled by the v-list-item `to` prop.
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .v-list-item {
    min-height: 34px;
    margin: 1px 0;
    border-radius: 7px;
    color: #cbd5e1 !important;
    padding: 0 10px !important;
    transition: background-color 0.16s ease, color 0.16s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.08);
      color: #ffffff !important;
    }
  }

  .v-list-item--active,
  .menu-item--active {
    background: rgba(255, 255, 255, 0.12) !important;
    color: #ffffff !important;
    box-shadow: none;
  }

  .menu-item--active::before {
    opacity: 0 !important;
  }

  .v-list-item__icon {
    margin: 7px 12px 7px 0 !important;
    min-width: 20px;
  }

  .v-list-item__content {
    padding: 6px 0 !important;
  }

  .v-icon {
    color: currentColor !important;
    font-size: 19px !important;
  }

  .v-list-item__title {
    color: currentColor !important;
    font-size: 12.5px;
    font-weight: 650;
    line-height: 1.3;
  }
  </style>
  
